import React, { forwardRef, Fragment, useImperativeHandle, useState, useEffect } from 'react';

import { isRobot } from '@/utils/common/device';

export type LazyProps = {
  visible?: boolean;
  onBeforeShow?: (show: () => void) => void;
  onCancel?: (show?: () => void) => void;
  showModal?: (show: () => void) => void;
  [key: string]: any;
};

export default function withLazy(ComposeComponent, isLazy?) {
  const LazyComponent = (props: LazyProps, ref) => {
    const { visible: vis = false, onBeforeShow, children, ...others } = props;
    const [visible, setVisible] = useState<boolean>(vis);
    const [loaded, setLoaded] = useState<boolean>(!(isLazy ?? true));
    let moChildren = !children;
    const showModal = (e?) => {
      if (isRobot()) {
        setVisible(false);
        return;
      }
      e?.stopPropagation();
      e?.preventDefault();
      setLoaded(true);
      setVisible(true);
    };
    const hideModal = (e?) => {
      e?.stopPropagation();
      setVisible(false);
    };
    const handleBefore = () => {
      onBeforeShow?.(showModal);
    };
    useEffect(() => {
      if (moChildren) {
        setVisible(vis);
      }
    }, [moChildren, vis]);
    useImperativeHandle(ref, () => ({
      show: onBeforeShow ? handleBefore : showModal,
      hide: hideModal
    }));
    if (!children) {
      return <ComposeComponent {...props} onCancel={hideModal} visible={visible} />;
    }
    return (
      <Fragment>
        {React.cloneElement(children, {
          onClick: onBeforeShow ? handleBefore : showModal
        })}
        {!!loaded && <ComposeComponent {...others} showModal={showModal} onCancel={hideModal} visible={visible} />}
      </Fragment>
    );
  };
  return forwardRef(LazyComponent);
}
